export default __webpack_public_path__ + "static/media/overviewBgMobile.a1ffb5ce.png";